import React, {useState, useEffect} from 'react';
import {getTopicsList, postTopicReg, putTopic} from "../../api/apiClient";
import {Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import DivisionPurposeMQTTInlineBox from "../../components/searchBoxs/DivisionPurposeMQTTInlineBox";
import TopicSettingBox from "../../components/searchBoxs/TopicSettingBox";
import TableTopicSetting from "../../components/tables/TableTopicSetting";
import Swal from "sweetalert2";

const MqttTopicReg = ({
                        setIsReadOnly = false,
                        propInfo,
                        propMqttId,
                        propPrpos,
                        propSe,
                        propSeNm,
                        propTableList,
                      }) => {

  const [type, setType] = useState("post");
  const [topicInfo, setTopicInfo] = useState({
    mqttId: propMqttId,
    readPermission: 0,
    rm: '',
    topic: '',
    writePermission: 0,
  });

  /* pagination을 위한 state */
  const [listPageSize, setListPageSize] = useState(15);
  const [tableList, setTableList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const updateList = () => {
    // mqttId 삽입 필요
    getTopicsList(currentPage, listPageSize,
        propInfo.mqtt_id)
        .then((res) => {
              // console.log(res);
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (type === "post") {
      postTopicReg(topicInfo)
          .then((res) => {
            if (res.status === 200) {
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
            }
            onReset();
            updateList();
          })
          .catch((err) => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    } else if (type === "put") {
      putTopic(topicInfo)
          .then((res) => {
            if (res.status === 200) {
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
            }
            onReset();
            updateList();
          })
          .catch((err) => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    }
  };

  const onReset = () => {
    setTopicInfo({
      mqttId: propMqttId,
      readPermission: 0,
      rm: "",
      topic: "",
      writePermission: 0,
    });
    setType("post");
  };


  useEffect(() => {
    updateList();
  }, [propInfo, currentPage, listPageSize]);

  return (
      <Container fluid>
        <Row className={"p-3"}>

          <Col md={12} className={"search-container py-2"}>
            <DivisionPurposeMQTTInlineBox
                propInfo={propInfo}
                propMqttId={propMqttId}
                propSe={propSe}
                propPrpos={propPrpos}
                propSeNm={propSeNm}
            />
          </Col>

          <Col md={12} className={"search-container mt-3 py-2"}>
            <TopicSettingBox
                updateList={updateList}
                propMqttId={propMqttId}
                propTopicInfo={topicInfo}
                propSetTopicInfo={setTopicInfo}
                propType={type}
                propSetType={setType}
                propOnSubmit={onSubmit}
                propOnReset={onReset}
            />
          </Col>

          <Col md={12} className={"table-container mt-3 py-2 mw-100"}>
            <TableTopicSetting
                propMqttId={propMqttId}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                listPageSize={listPageSize}
                setListPageSize={setListPageSize}
                total={total}
                tableList={tableList}
                updateList={updateList}
                propSetTopicInfo={setTopicInfo}
                propSetType={setType}
                setTableList={setTableList}
                setTotal={setTotal}
            />
          </Col>
        </Row>
      </Container>
  );
};

export default MqttTopicReg;
